"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * On Web we need to include an actual input but hide it.
 */const RadioInput = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    checked,
    defaultChecked,
    disabled = false,
    id = null,
    isControlled = false,
    name,
    onChange = () => {},
    value
  } = _ref;
  const handleClick = event => {
    // Cancel the click dispatched via the label tag, since it's already wrapped
    // in <Pressable>
    event.preventDefault();
    event.stopPropagation();
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
    checked: isControlled ? checked : undefined,
    defaultChecked: isControlled ? undefined : defaultChecked,
    disabled: disabled,
    hidden: true,
    id: id,
    name: name,
    onChange: onChange,
    onClick: handleClick,
    ref: ref,
    type: "radio",
    value: value
  });
});
RadioInput.displayName = 'Radio';
RadioInput.propTypes = {
  checked: _propTypes.default.bool,
  defaultChecked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  id: _propTypes.default.string,
  isControlled: _propTypes.default.bool,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool])
};
var _default = exports.default = RadioInput;